<template>
  <div class="count-down">
    <span class="minute">{{ pad(minutes) }}</span>
    <span class="middle">:</span>
    <span class="seconds">{{ seconds }}</span>
  </div>
</template>

<script>
  export default {
    name: 'CountDown',
    props: {
      totalTime: Number,
      isGetTimer: Boolean
    },
    data () {
      return {
        minutes: 0,
        seconds: '00',
        timer: null,
        startTimeExam: 0,
        endTimeExam: 0
      }
    },
    watch: {
      isGetTimer (newval) {
        if (newVal) {
          this.handleEditData()
        }
      },
    },
    mounted () {
      this.startTimeExam = new Date;
      this.minutes = this.totalTime
      this.startTimer()
    },
    beforeDestroy () {
      // this.handleEditData()
      clearInterval(this.timer)
    },
    methods: {

      startTimer () {
        let self = this
        let minute = 60*1000;
        let total = self.totalTime*minute

        self.timer = setInterval(function () {
          if (self.minutes === 0 && self.seconds === '00') {
            clearInterval(self.timer)
            self.handleEditData()
          } else {
            if(total > -1) {
              total -= 1
            }
            self.seconds = self.pad(parseInt(total % 60, 10));
            if (self.seconds === '59') {
              self.minutes -= 1
            }
          }
        }, 1000);
      },

      handleEditData () {
        this.endTimeExam = new Date;
        this.$emit('theEnd', this.callTimeDiff())
      },

      pad (val) {
        return (val < 10 ? '0' : '') + val;
      },

      callTimeDiff() {
        let oneMinute = 60;
        let timeDiff = this.endTimeExam - this.startTimeExam; //in ms
        // strip the ms
        timeDiff /= 1000;
        // get seconds 
        let totalTime = Math.round(timeDiff);
        let minute = Math.floor(totalTime/oneMinute);
        let seconds = totalTime%oneMinute;
        return {minute, seconds};
      },
    }
  }
</script>

<style lang="css" scoped>
</style>